import wrapper from 'wrapper';

export default class Pocket {
    constructor(pocketElement) {
        this.dom = {
            root: pocketElement,
            tapArea: wrapper.scope.querySelector('.pocket__tap-area'),
            button: wrapper.scope.querySelector('.pocket__button'),
        };
        this.regions = wrapper.getConfig().app.meta.regions;
        this.data = wrapper.getConfig().app.data;
        this.regionLengths = this.setRegionLengths();
        this.isExpanded = !pocketElement.classList.contains('pocket--less');
        window.addEventListener('updated-filter', (evt) => {
            const region = evt.detail;
            this.filter(region);
            this.fold();
            this.setTableHeight(region);
            this.setShowMoreButton(region);
        });
    }

    expand() {
        this.dom.root.classList.remove('pocket--less');
        this.dom.root.style.height = '80vh';
        this.dom.button.innerText = __('table_collapse');
        this.isExpanded = true;
        this.dispatchEvent();
        return true;
    }

    fold() {
        this.dom.root.classList.add('pocket--less');
        this.dom.root.style.height = '27rem';
        this.dom.button.innerText = __('table_expand');
        this.isExpanded = false;
        this.dispatchEvent();
        return true;
    }

    getRegionLength(region) {
        return this.regionLengths[region];
}

    setRegionLengths() {
        const regionLengths = {};
        this.regions.forEach(region => {
            const regionLength = wrapper.selectAll(`tr.${region}`);
            regionLengths[region] = regionLength.length;
        });
        return regionLengths;
    }

    setTableHeight(region) {
        const defaultFoldedTableHeight = 432;
        let tableHeight;
        const th = wrapper.select('thead');
        const tbody = wrapper.select('tbody');
        const bottomPadding = 32;
        if (this.getRegionLength(region) <= 6 && region !== 'region_world') {
            tableHeight = th.clientHeight + tbody.clientHeight + bottomPadding;
        }
        else {
            tableHeight = defaultFoldedTableHeight;
        }
        this.dom.root.style.height = `${tableHeight}px`;
    }

    setShowMoreButton(region) {
        wrapper.select('.pocket__tap-area').classList.remove('disabled');
        if (this.getRegionLength(region) <= 6 && region !== 'region_world') {
            wrapper.select('.pocket__tap-area').classList.add('disabled');
        }
    }

    dispatchEvent() {
        window.dispatchEvent(new CustomEvent('pocket-status-changed'));
    }

    onClick(e) {
        e.target.blur();
        if (this.isExpanded) {
            return this.fold();
        }
        return this.expand();
    }

    connect() {
        this.dom.tapArea.addEventListener('click', this.onClick.bind(this));
    }

    filter(region) {
        this.regions.forEach(r => {
            if (r === region) {
                this.dom.root.classList.add(r);
            }
            else {
                this.dom.root.classList.remove(r);
            }
        });
    }
}
